import React from 'react';
import { FaArrowLeft } from 'react-icons/fa';
import PropTypes from 'prop-types';

const BackButton = ({ onClick, className = '', ariaLabel = 'Go Back', style = {} }) => {
    return (
        <button
            onClick={onClick}
            className={`ui-back-btn ${className}`}
            aria-label={ariaLabel}
            style={style}
        >
            <FaArrowLeft />
        </button>
    );
};

BackButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    className: PropTypes.string,
    ariaLabel: PropTypes.string,
    style: PropTypes.object
};

export default BackButton;
